import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LabadminService } from 'src/app/labadmin/labadmin.service';
import { formatLotDecimal } from 'src/app/labadmin/components/Utility Functions';

@Component({
  selector: 'app-lot-preview',
  templateUrl: './lot-preview.component.html',
  styleUrls: ['./lot-preview.component.scss']
})
export class LotPreviewComponent implements OnInit{
  status : 'active' | 'inactive' = 'active';
  SD :string = ''
  deviationType : string = 'standard'
  sign : 'SD' | '%' | '' = ''
  setDifferentMinMaxDeviation : boolean = true
  searchValue : string = ''
  alertLessLots : boolean = false
  objectValues =[]
  lotData : any;
  isFullScreenEnabled : boolean = false
  estimatedLotExpiryDate = formatDate(new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),'MM-dd-yyyy','en-US')
  expiryDate : string = ''
  showTotalUnits: boolean = true
  
  constructor(
    private _labadminservice: LabadminService,
    private _snackbar: MatSnackBar,
    private _dialogRef: MatDialogRef<LotPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public config: any,
  ) { 
    this.isFullScreenEnabled = (this._labadminservice?.redirectToMenu ?? '') != ''
  }
  showLoader :boolean = false;

  ngOnInit(): void {
    this.deviationType = this.config.data.deviationType.toLowerCase()
    this.showTotalUnits = this.config.showTotalUnits
    if(this.config.data.deviationType){
      if(this.config.data.deviationType.toLowerCase() == 'standard'){
        this.config.data.deviationType = 'Standard Deviation (SD)'
        this.sign = 'SD'
      }
      else if(this.config.data.deviationType.toLowerCase() == 'percent'){
        this.config.data.deviationType = 'Percentage (%)'
        this.sign = '%'
      }
      else if(this.config.data.deviationType.toLowerCase() == 'referencerange'){
        this.config.data.deviationType = 'Reference Range'
        this.sign = ''
      }
      else if (this.config.data.deviationType.toLowerCase() == 'qualitativeresults') {
        this.config.data.deviationType = 'Qualitative Results';
        this.sign = '';
      }
    }
    else this.config.data.deviationType = 'N/A'
    this.getAssociatedResults(this.config.data.lotId)
    this.alertLessLots = this.config.data.avialableTotalUnits.split('/')[0] <= Math.round(this.config.data.avialableTotalUnits.split('/')[1] * 0.1)
    if(!this.config.data.status) this.status = 'inactive'
    if(this.config.data.expiryDate && new Date(this.config.data.expiryDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) this.expiryDate =  'Expired'
  }

    getAssociatedResults(lotId: any) {
        this.showLoader=true
        this._labadminservice.GetLotDetails(this._labadminservice.deploymentKey,lotId,this.config.loggedinUserOrgID).subscribe({
            next:(response :any)=>
              {  
                //this.deviationType = response.DerivationType;
                const barcodeDetails = response.BarCodeDetails.reduce((acc, { OrdercodeID, Barcode, PanelName }) => {

                    if (!acc[OrdercodeID]) {
                      acc[OrdercodeID] = { OrdercodeID, PanelName, Barcodes: [], results: [] };
                    }
                    acc[OrdercodeID].Barcodes.push(Barcode);
                    return acc;
                  }, {} as Record<number, { OrdercodeID: number; PanelName: string; Barcodes: string[]; results: any[] }>);
                  
                  const resultCodeDetailsMap = response.ResultCodeDetails?.reduce((acc, item) => {
                    if (!acc[item.OrderCodeID]) acc[item.OrderCodeID] = [];
                    acc[item.OrderCodeID].push(item);
                    return acc;
                  }, {} as Record<number, any[]>);
                  

                  const casetype = response.Casetype ?? this.config.data?.casetype ?? this.config.data?.casetypeDisplayName;
                  this.objectValues = Object.values(barcodeDetails).map((barcode:any) => ({
                    panelName: barcode.PanelName,
                    Barcodes: barcode.Barcodes,
                    results: (resultCodeDetailsMap[barcode.OrdercodeID] || []).map(test => {
                      const minD = test.MinNumberOfDecimal;
                      const maxD = test.NumberofDecimal;
                      const f = (v: any) => formatLotDecimal(v, minD, maxD, casetype);
                      return {
                        siteName: test.ResultName,
                        machineTargetValue: f(test.machineTargetValue),
                        standardDeviation: f(test.standardDeviation),
                        minAcceptableDeviation: f(test.minAcceptableDeviation),
                        maxAcceptableDeviation: f(test.maxAcceptableDeviation),
                        minAcceptableRange: f(test.minAcceptableRange),
                        maxAcceptableRange: f(test.maxAcceptableRange),
                        targetValue: f(test.targetValue),
                        qualitativeTargetValue: test.qualitativeTargetValue
                      };
                    })                
                  }));          
             
              },
              error: (err) => {
                this.showLoader=false
                // this._snackbar.open('Something went wrong','Close')
                this._snackbar?.open('Something went wrong', null, {
                  panelClass: ['failure-snackbar']
                });
          
                console.error('Error:', err);
              },complete:()=>this.showLoader=false
          })
    }
    compareTwoDates (date1:string,date2:string) {
      if(date1 && date2)return new Date(date1) >= new Date(date2)
      else return false
    }

    
  lotNumericExceedsSixDigits(value: number | string | null | undefined): boolean {
    const s = value === null || value === undefined || value === '' ? '' : String(value);
    return s.replace(/[^0-9]/g, '').length > 6;
  }

}
